import axios from 'axios';
import { getDemoCrudIntApiUrl } from '../../../config/api';

export default class DemoCrudIntService {
  constructor() {
    this.registros = [];
    this.loading = false;
    this.error = null;
    this.sortField = null;
    this.sortDirection = 'asc';
    this.currentPage = 1;
    this.itemsPerPage = 10;
  }

  // Inicializar el servicio
  async initialize() {
    await this.listar();
  }

  // Listar registros
  async listar() {
    this.loading = true;
    this.error = null;

    console.log('Cargando registros de DemoCrudInt...');
    
    try {
      const response = await axios.post(getDemoCrudIntApiUrl('/api/DemoCrudInt/listar'), {});
      
      this.registros = response.data || [];
      this.loading = false;
      
      return {
        success: true,
        data: this.registros,
        message: 'Registros cargados exitosamente'
      };
    } catch (error) {
      console.error('Error al cargar registros:', error);
      this.error = 'No se pudieron cargar los registros. Por favor, intente nuevamente.';
      this.loading = false;
      throw error;
    }
  }

  // Guardar registro (insert/update)
  async guardar(registro) {
    try {
      console.log('Guardando registro:', registro);
      
      const response = await axios.post(getDemoCrudIntApiUrl('/api/DemoCrudInt/guardar'), registro);
      
      // Recargar la lista después de guardar
      await this.listar();
      
      return {
        success: true,
        data: response.data,
        message: registro.DemoInt && registro.DemoInt > 0 ? 'Registro actualizado exitosamente' : 'Registro creado exitosamente'
      };
    } catch (error) {
      console.error('Error al guardar registro:', error);
      throw error;
    }
  }

  // Leer un registro específico
  async lectura(demoInt) {
    try {
      console.log('Leyendo registro:', demoInt);
      
      const response = await axios.post(getDemoCrudIntApiUrl('/api/DemoCrudInt/lectura'), {
        DemoInt: demoInt
      });
      
      return {
        success: true,
        data: response.data,
        message: 'Registro encontrado'
      };
    } catch (error) {
      console.error('Error al leer registro:', error);
      throw error;
    }
  }

  // Borrar registro
  async borrar(demoInt) {
    try {
      console.log('Eliminando registro:', demoInt);
      
      const response = await axios.post(getDemoCrudIntApiUrl('/api/DemoCrudInt/borrar'), {
        DemoInt: demoInt
      });
      
      // Recargar la lista después de eliminar
      await this.listar();
      
      return {
        success: true,
        data: response.data,
        message: 'Registro eliminado exitosamente'
      };
    } catch (error) {
      console.error('Error al eliminar registro:', error);
      throw error;
    }
  }

  // Recargar registros
  async recargar() {
    console.log('Recargando registros...');
    await this.listar();
  }

  // Ordenar datos
  sort(field) {
    if (this.sortField === field) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortDirection = 'asc';
    }
  }

  // Obtener datos ordenados
  get sortedData() {
    if (!this.sortField) return this.registros;
    
    return [...this.registros].sort((a, b) => {
      let aVal = a[this.sortField];
      let bVal = b[this.sortField];
      
      // Manejar fechas
      if (this.sortField === 'FechaInserta') {
        aVal = new Date(aVal);
        bVal = new Date(bVal);
      }
      
      // Manejar números
      if (typeof aVal === 'number' && typeof bVal === 'number') {
        return this.sortDirection === 'asc' ? aVal - bVal : bVal - aVal;
      }
      
      // Manejar strings
      if (typeof aVal === 'string' && typeof bVal === 'string') {
        return this.sortDirection === 'asc' 
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
      }
      
      // Manejar fechas
      if (aVal instanceof Date && bVal instanceof Date) {
        return this.sortDirection === 'asc' ? aVal - bVal : bVal - aVal;
      }
      
      return 0;
    });
  }

  // Obtener datos paginados
  get paginatedData() {
    const sorted = this.sortedData;
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    return sorted.slice(start, end);
  }

  // Obtener total de páginas
  get totalPages() {
    return Math.ceil(this.registros.length / this.itemsPerPage);
  }

  // Obtener icono de ordenamiento
  sortIcon(field) {
    if (this.sortField !== field) return 'bi bi-arrow-down-up';
    return this.sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down';
  }

  // Cambiar página
  changePage(page) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }
}